class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const buildAllParams = () => {
      const form1 = document.querySelector('.facets-vertical-form');
      const form2 = document.querySelector('.facets__form-vertical');
      let allParams = [];
      if (form1) {
        const params1 = this.createSearchParams(form1);
        if (params1) allParams.push(params1);
      }
      if (form2) {
        const params2 = this.createSearchParams(form2);
        if (params2) allParams.push(params2);
      }
      return allParams.join('&');
    };

    const applyBtn = document.querySelector('.btn-filter-apply');
    // PCY drawer kendi pending-state/Apply akışını yönetiyor. Buraya da listener
    // bağlanırsa sayfadaki her facet-filters-form aynı tıklamada tekrar render başlatır.
    if (applyBtn && !applyBtn.closest('.pcy-filters-drawer')) {
      applyBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.onSubmitForm(buildAllParams(), event);
      });
    }

    // Bir filtre seçeneği işaretlenir işaretlenmez sayaç/grid canlı güncellensin
    // (URL'yi henüz değiştirmiyoruz, o Apply'a basınca oluyor)
    document.addEventListener('change', (event) => {
      // PCY drawer seçimleri Apply'e kadar pending kalır; grid burada render edilmez.
      if (event.target.closest('.pcy-filters-drawer')) return;
      const isFilterCheckbox = event.target.closest('.facets__form-vertical');
      const isPriceRange = event.target.closest('.facets__form-vertical price-range');
      if (!isFilterCheckbox && !isPriceRange) return;
      FacetFiltersForm.renderPage(buildAllParams(), event, false, false);
    });
  }

  // -----------------------------
  // Yardımcılar (fiyat normalizasyonu)
  // -----------------------------
  _normalizeVisiblePrice(val) {
    if (val == null) return null;
    let s = String(val).trim();
    if (!s) return null;
    // 1.200,50 -> 1200.50
    s = s.replace(/\./g, '').replace(',', '.');
    const num = parseFloat(s);
    if (isNaN(num)) return null;
    // URL major unit istiyoruz
    return String(Math.round(num));
  }

  _getVisiblePricePair(form) {
    const minVisible = form.querySelector('input[name$=".price.gte"], input[name="filter.v.price.gte"]:not([type="hidden"])');
    const maxVisible = form.querySelector('input[name$=".price.lte"], input[name="filter.v.price.lte"]:not([type="hidden"])');
    const minVal = minVisible ? this._normalizeVisiblePrice(minVisible.value) : null;
    const maxVal = maxVisible ? this._normalizeVisiblePrice(maxVisible.value) : null;
    return { minVal, maxVal };
  }

  _maybeFixMinorToMajor(v) {
    // Gizli input'tan (minor unit) gelmiş gibi duran değeri majore çevir (örn. 12000 -> 120)
    if (v == null) return null;
    const n = parseInt(String(v), 10);
    if (isNaN(n)) return null;
    // Heuristik: 100'e tam bölünüyorsa ve 1000+'se, majore indir
    if (n >= 1000 && n % 100 === 0) {
      return String(Math.round(n / 100));
    }
    return String(n);
  }

  // -----------------------------

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, showOverlay = true) {
    const normalizedParams = FacetFiltersForm.withAvailability(searchParams);
    searchParams = normalizedParams.toString();
    const normalizedEntries = Array.from(normalizedParams.entries()).sort(([keyA, valueA], [keyB, valueB]) => {
      const keyCompare = keyA.localeCompare(keyB);
      return keyCompare || valueA.localeCompare(valueB);
    });
    const renderKey = `${window.location.pathname}?${new URLSearchParams(normalizedEntries).toString()}`;
    const renderStartedAt = performance.now();
    if (FacetFiltersForm.lastRenderKey === renderKey && renderStartedAt - FacetFiltersForm.lastRenderStartedAt < 200) {
      return;
    }
    FacetFiltersForm.lastRenderKey = renderKey;
    FacetFiltersForm.lastRenderStartedAt = renderStartedAt;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const sectionRequests = sections.map((section) => ({
      section,
      url: `${window.location.pathname}?section_id=${section.section}&${searchParams}`,
    }));
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const countContainerApply = document.getElementById('ProductCountFilterApply');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (countContainerApply) countContainerApply.classList.add('loading');
    if (productGridContainer) productGridContainer.classList.add('loading');
    if (showOverlay) {
      if (countContainer) countContainer.classList.add('loading');
      if (countContainerDesktop) countContainerDesktop.classList.add('loading');
    }

    sectionRequests.forEach(({ url }) => {
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        try {
          FacetFiltersForm.renderFilters(html, event);
        } catch (err) {
          console.error('renderFilters error:', err);
        }
        try {
          FacetFiltersForm.renderProductGridContainer(html);
        } catch (err) {
          console.error('renderProductGridContainer error:', err);
        }
        try {
          FacetFiltersForm.renderProductCount(html);
        } catch (err) {
          console.error('renderProductCount error:', err);
        }
        try {
          if (typeof initializeScrollAnimationTrigger === 'function') {
            const grid = document.getElementById('ProductGridContainer');
            if (grid) initializeScrollAnimationTrigger(grid);
          }
        } catch (err) {
          console.error('initializeScrollAnimationTrigger error:', err);
        }
      })
      .catch((err) => {
        console.error('renderSectionFromFetch error:', err);
        FacetFiltersForm.clearLoadingState();
      });
  }

  static updateActiveFilterCount() {
    const form = document.getElementById('FacetFiltersForm');
    const badge = document.getElementById('PcyFilterActiveCount');
    if (!form) return;
    const activeCount = form.querySelectorAll(
      '.js-filter input[type="checkbox"]:checked, .js-filter input[type="radio"]:checked'
    ).length;
    if (badge) {
      if (activeCount > 0) {
        badge.textContent = `(${activeCount})`;
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    }
    FacetFiltersForm.updateToolbarFilterCount(activeCount);
  }

  static updateToolbarFilterCount(activeCount) {
    document.querySelectorAll('.btn-filter.pcy-filter-btn').forEach((button) => {
      // Header search modal has its own isolated filter state. The page-level
      // facet count must never overwrite the modal toolbar count.
      if (button.closest('.search-overlay')) return;
      let toolbarCount = button.querySelector('[data-pcy-filter-active-count]');
      const label = button.querySelector('b') || button.querySelector('span') || button;
      if (!toolbarCount) {
        toolbarCount = document.createElement('span');
        toolbarCount.setAttribute('data-pcy-filter-active-count', '');
      }
      if (toolbarCount.parentElement !== label) label.appendChild(toolbarCount);
      toolbarCount.textContent = ` (${activeCount})`;
      toolbarCount.toggleAttribute('hidden', activeCount === 0);
    });
  }

  static clearLoadingState() {
    document.querySelector('body').classList.remove('loading');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) productGridContainer.classList.remove('loading');
    ['ProductCount', 'ProductCountDesktop', 'ProductCountFilterApply'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('loading');
    });
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newGridContainer = parsedHTML.getElementById('ProductGridContainer');
    const currentGridContainer = document.getElementById('ProductGridContainer');
    if (newGridContainer && currentGridContainer) {
      currentGridContainer.innerHTML = newGridContainer.innerHTML;
      currentGridContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countSource =
      parsedHTML.getElementById('ProductCount') ||
      parsedHTML.getElementById('ProductCountDesktop') ||
      parsedHTML.getElementById('ProductCountFilterApply');
    const count = countSource ? countSource.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container && count) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop && count) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const applyCountContainer = document.getElementById('ProductCountFilterApply');
    if (applyCountContainer && count) {
      const firstNumberMatch = count.replace(/<[^>]*>/g, '').match(/\d+/);
      applyCountContainer.innerHTML = firstNumberMatch ? firstNumberMatch[0] : count;
      applyCountContainer.classList.remove('loading');
    }
    FacetFiltersForm.updateActiveFilterCount();
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) productGridContainer.classList.remove('loading');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    document.querySelector('body').classList.remove('loading');

    const facetFormEvent = new Event("facetFiltersFormSubmit");
    document.dispatchEvent(facetFormEvent);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const openDetailIds = new Set(
      Array.from(document.querySelectorAll('#FacetFiltersForm details[open], .pcy-filters-drawer details[open], #main-search-filters details[open], facet-filters-form details[open], .facets-vertical details[open]')).map(
        (d) => d.id
      ).filter(Boolean)
    );

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event && event.target ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        const wasOpen = currentElement.hasAttribute('open') || openDetailIds.has(currentElement.id);
        currentElement.innerHTML = elementToRender.innerHTML;
        if (wasOpen) currentElement.setAttribute('open', '');
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target && event.target.closest('.js-filter')) {
      const closestJSFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestJSFilter.id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestJSFilter);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (openDetailIds.has(closestJSFilterID) || closestJSFilter.hasAttribute('open')) {
          newFacetDetailsElement?.setAttribute('open', '');
        }

        const newElementSelector = newFacetDetailsElement?.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement?.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }

    openDetailIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el && !el.hasAttribute('open')) el.setAttribute('open', '');
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileMenu = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (mobileMenu && typeof mobileMenu.bindEvents === 'function') {
      mobileMenu.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.replaceState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static withAvailability(searchParams = '') {
    const params = new URLSearchParams(searchParams);
    // Facet counts must describe purchasable products, not sold-out products.
    // Keep availability in Shopify's server-side query so every dependent
    // count is recalculated from the same result set as the product grid.
    params.set('filter.v.availability', '1');
    return params;
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    if (productGrid && productGrid.dataset && productGrid.dataset.id) {
      return [{ section: productGrid.dataset.id }];
    }
    const drawer = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
    if (drawer && drawer.dataset && drawer.dataset.id) {
      return [{ section: drawer.dataset.id }];
    }
    const sectionEl = document.querySelector('.facets-vertical, .facets-wrapper');
    const sectionId = sectionEl?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    return [{ section: sectionId || '' }];
  }

  createSearchParams(form) {
    const fd = new FormData(form);

    fd.set('filter.v.availability', '1');

    fd.delete('filter.v.price.gte');
    fd.delete('filter.v.price.lte');

    const { minVal, maxVal } = this._getVisiblePricePair(form);
    if (minVal !== null) fd.set('filter.v.price.gte', minVal);
    if (maxVal !== null) fd.set('filter.v.price.lte', maxVal);

    if (minVal === null) {
      const hiddenMin = form.querySelector('input[type="hidden"][name="filter.v.price.gte"]');
      if (hiddenMin && hiddenMin.value !== '') {
        fd.set('filter.v.price.gte', this._maybeFixMinorToMajor(hiddenMin.value));
      }
    }
    if (maxVal === null) {
      const hiddenMax = form.querySelector('input[type="hidden"][name="filter.v.price.lte"]');
      if (hiddenMax && hiddenMax.value !== '') {
        fd.set('filter.v.price.lte', this._maybeFixMinorToMajor(hiddenMax.value));
      }
    }

    if (!fd.get('filter.v.price.gte')) fd.delete('filter.v.price.gte');
    if (!fd.get('filter.v.price.lte')) fd.delete('filter.v.price.lte');

    return new URLSearchParams(fd).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const target = event.target;
    if (target && (target.name === 'sort_by' || target.id === 'SortBy' || target.id === 'SortBy-mobile')) {
      const url = new URL(window.location.href);
      const val = target.value || '';
      if (val) url.searchParams.set('sort_by', val);
      else url.searchParams.delete('sort_by');
      const sp = url.search.slice(1);
      this.onSubmitForm(sp, event);
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.lastRenderKey = '';
FacetFiltersForm.lastRenderStartedAt = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = FacetFiltersForm.searchParamsInitial;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

FacetFiltersForm.updateActiveFilterCount();
